import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';


export default class JtMultiSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			selected: []
		};
		this.clickOpen =  this.clickOpen.bind(this);
		this.applyMultiSelected = this.applyMultiSelected.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	clickOpen() {
	    if (!this.state.open) {
	      // attach/remove event handle
	      document.addEventListener('click', this.handleOutsideClick, false);
	    } else {
	      document.removeEventListener('click', this.handleOutsideClick, false);
	    }

	    if(!this.state.open) {
			for(var i of this.props.options) {
				i.checked = false;
			}
			this.setState({
				selected: [],
				open: true
			})
		} else {
			this.setState({
			open: false
			});
		}

	    // this.setState(prevState => ({
	    //    open: !prevState.open,
	    // }));
  	}
  
  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }
    
    this.clickOpen();
  }


	// clickOpen() {
	// 	if(!this.state.open) {
	// 		for(var i of this.props.options) {
	// 			i.checked = false;
	// 		}
	// 		this.setState({
	// 			selected: [],
	// 			open: true
	// 		})
	// 	} else {
	// 		this.setState({
	// 		open: false
	// 		});
	// 	}
	// }

	selectOption(option) {
		var selected = this.state.selected;
		if(option.checked) {
			option.checked = false;
			for(var i in selected) {
				if(selected[i].spaceName === option.spaceName) {
					break;
				}
			}
			selected.splice(i,1);
		} else {
			option.checked = true;
			selected.push(option);
		}
		this.setState({
			selected: selected
		});
	}

	applyMultiSelected() {
		if(this.state.selected.length > 0) {
			var selected = this.state.selected;
			this.clickOpen();
			this.props.applyMultiSelected(selected);
		}
	}

	options() {
		var options = this.props.options.map((option, index) => {
			if(option.checked === undefined) {
				option.checked = false
			}
			return (
				<div key={index} className="option-wrapper" onClick={() => this.selectOption(option)}>
					<div className="user-option">
						<div className="pull-left" style={{whiteSpace:'nowrap'}}>
							<Checkbox checked={option.checked} value={option.spaceName} classes={{root:'cstmCheckBox',checked:'greenChecked'}}/> <span style={{marginLeft:'20px',lineHeight:'22px',fontSize:'17px'}}>{option.spaceName}</span>
						</div>
					</div>
				</div>

			);
		});
		return options;
	}


	render() {
		return(
			<div ref={node => { this.node = node; }}>
				<button className="btn btn-default drop-btn" onClick={this.clickOpen}>
					{
						<div className="twenty-four-line">
							{this.props.title} <div className="pull-right">{(this.state.open)?<i className="fas fa-chevron-up"></i>:<i className="fas fa-chevron-down"></i>}</div>
						</div>
					} 
				</button>
				{(this.state.open) ?
				<div>
					<div className="drop-down-selector">
						{this.options()}
						<div style={{display:'flow-root',padding:'0 10px 10px 10px'}}>
							<button className="btn btn-jt-primary pull-right" disabled={this.state.selected.length < 1} onClick={this.applyMultiSelected}>Apply</button>
						</div>
					</div>
				</div>:null
				}
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/commons/JtMultiSelect.js